import { ActionManageType } from './common/type';

export const EarnEvent = {
  HistoryClick: 'earn_history_click',
  ExtraExpandClick: 'earn_extra_expand_click',
  EarnBannerView: 'earn_banner_view',
  EarnBannerClick: 'earn_banner_click',
  EarnBenefitActionClick: 'earn_benefit_action_click',
  EarnTabAprBenefitCheckNowClick: 'earn_tab_apr_benefit_check_now_click',
  PnlBannerView: 'pnl_banner_view',
  PnlBannerClick: 'pnl_banner_click',
  PnlBannerCloseClick: 'pnl_banner_close_click',
  EarnPoolPageView: 'earn_pool_page_view',
  TradingVolumeTierDetailsClick: 'trading_volume_tier_details_click',
  EarnTabTotalUsdtTradeClick: 'earn_tab_total_usdt_trade_click',
  EarnTabTotalUsdtDetailsClick: 'earn_tab_total_usdt_details_click',

  // New User Pool Events
  EarnTabViewNewJoinerPool: 'userpool_page_view',
  EarnTabViewPromoBanner: 'earn_tab__view_promo_banner',
  EarnTabClickPromoBanner: 'earn_tab__click_promo_banner',
  EarnTabClosePromoBanner: 'earn_tab__close_promo_banner',
  EarnTabClickCumulativeEarnings: 'earn_tab__click_cumulative_earnings',
  EarnTabJoinNewJoinerPool: 'earn_tab__join_new_joiner_pool',
  EarnTabClickNewJoinerPoolTotalReward: 'earn_tab__click_new_joiner_pool_total_reward',
  EarnTabViewNewJoinerPoolToast: 'earn_tab__view_new_joiner_pool_toast',
  EarnTabViewNewJoinerPoolRestrictedLocation: 'earn_tab__view_new_joiner_pool_restricted_location',
  EarnTabClickNewJoinerPoolMissionButton: 'earn_tab__click_new_joiner_pool_mission_button',
  EarnTabViewNewJoinerPoolStatus: 'earn_tab__view_new_joiner_pool_status',

  EarnManageClick: 'earn_manage_click',
  EarnManageDetailsClick: 'earn_manage_details_click',
  EarnPreviewClick: 'earn_preview_click',
  EarnPreviewConfirmClick: 'earn_preview_confirm_click',
  EarnConfirmationPageView: 'earn_confirmation_page_view',
} as const;

export interface EarnEventDataType {
  [EarnEvent.HistoryClick]: {
    cumulative_earnings: number;
    estimated_earnings: number;
    usdt_balance: number;
    apr?: number;
  };
  [EarnEvent.ExtraExpandClick]: {
    base_apr: number;
    extra_apr: number;
    extra_apr_list: string[];
  };
  [EarnEvent.EarnBannerView]: {
    image_name: string;
    list_order: number;
  };
  [EarnEvent.EarnBannerClick]: {
    image_name: string;
  };
  [EarnEvent.EarnBenefitActionClick]: {
    action_type: 'deposit' | 'trade';
    estimated_earnings: number;
    apr: number;
    additional_trade?: number;
    additional_deposit?: number;
  };
  [EarnEvent.PnlBannerClick]: {
    symbol: string;
    side: 'buy' | 'sell';
    realized_pnl: number;
    page_type: string; // 'trade_page', 'earn_page'
  };
  [EarnEvent.PnlBannerCloseClick]: {
    page_type: string; // 'trade_page', 'earn_page'
  };
  [EarnEvent.EarnTabTotalUsdtDetailsClick]: {
    asset_type: 'usdt' | 'usdt_premium';
  };
  [EarnEvent.EarnTabJoinNewJoinerPool]: {
    pool_status: string;
    estimate_full_reward_usdt: number;
  };
  [EarnEvent.EarnTabClickNewJoinerPoolTotalReward]: {
    your_total_reward_usdt?: number;
  };
  [EarnEvent.EarnTabViewNewJoinerPoolToast]: {
    toast_text: string;
  };
  [EarnEvent.EarnTabClickNewJoinerPoolMissionButton]: {
    completed_tickets: number;
    total_tickets: number;
    button_text: string;
    mission_title: string;
  };
  [EarnEvent.EarnTabViewNewJoinerPoolStatus]: {
    pool_status: string;
    estimate_full_reward_usdt: number;
    your_total_reward_usdt?: number;
  };
  [EarnEvent.EarnManageClick]: {
    button_text: string;
    currency: string;
  };
  [EarnEvent.EarnManageDetailsClick]: {
    manage_type: ActionManageType;
    currency: string;
  };
  [EarnEvent.EarnPreviewClick]: {
    manage_type: ActionManageType;
    from_currency: string;
    to_currency: string;
    from_amount: string;
    to_amount: string;
    available_balance: string;
  };
  [EarnEvent.EarnPreviewConfirmClick]: {
    manage_type: ActionManageType;
    from_currency: string;
    to_currency: string;
    from_amount: string;
    to_amount: string;
  };
  [EarnEvent.EarnConfirmationPageView]: {
    manage_type: ActionManageType;
    from_currency: string;
    to_currency: string;
    from_amount: string;
    to_amount: string;
  };
}
